import React from "react";
import { Link } from "react-router-dom";
import "../App.scss";
import AiReadinessFunnel from "./AiReadinessFunnel";
import AppliedAiResearch from "./AppliedAiResearch";
import WhyWorkWithUs from "./WhyWorkWithUs";
import { useTranslation } from "lib/i18n";
import enclaveLogo from "../img/quivio-enclave/enclave.svg";

const Body = () => {
  const { t } = useTranslation();
  const updatePoints = Array.isArray(t("homeUpdate.points")) ? t("homeUpdate.points") : [];

  return (
    <>
      <section className="home-update">
        <div className="container">
          <article className="home-update-card">
            <div className="home-update-copy">
              <div className="home-update-product">
                <span className="home-update-logo-frame">
                  <img src={enclaveLogo} alt="" aria-hidden="true" />
                </span>
                <span className="home-update-product-text title-font-2">
                  <small>{t("homeUpdate.eyebrow")}</small>
                  <strong>{t("homeUpdate.productName")}</strong>
                  <em>{t("homeUpdate.productLabel")}</em>
                </span>
              </div>
              <h2 className="title-font">{t("homeUpdate.heading")}</h2>
              <p className="title-font-2">{t("homeUpdate.body")}</p>
              <div className="home-update-actions">
                <Link to="/quivio-enclave" className="btn cta-accent" role="button">
                  {t("homeUpdate.primaryCta")}
                </Link>
                <Link to="/blog/quivio-enclave" className="btn home-update-secondary" role="button">
                  {t("homeUpdate.secondaryCta")}
                </Link>
              </div>
            </div>
            <div className="home-update-panel" aria-label={t("homeUpdate.panelTitle")}>
              <div className="home-update-panel-top title-font-2">
                <span>{t("homeUpdate.panelTitle")}</span>
                <strong>{t("homeUpdate.panelStatus")}</strong>
              </div>
              <div className="home-update-panel-points">
                {updatePoints.map((point, index) => (
                  <span className="home-update-point" key={point}>
                    <strong>0{index + 1}</strong>
                    <span>{point}</span>
                  </span>
                ))}
              </div>
              <div className="home-update-receipt title-font-2">
                <span>{t("homeUpdate.receiptLabel")}</span>
                <strong>QE-KMS-01</strong>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className="about-us-area text-white">
        <div className="container text-center">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="about-us-text-area mb-5 mt-5">
                <h2 className="about-us-text title-font">
                  {t("about.heading")}
                </h2>
                <p className="mt-4 mb-4 title-font-2">
                  {t("about.bodyLead")}
                  <br />
                  {t("about.bodyTail")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AppliedAiResearch />
      <WhyWorkWithUs />
      <AiReadinessFunnel />

      <section className="lead">
        <div className="container text-center">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="lead-title text-white mb-5 mt-4">
                <h1 className="title-font">{t("lead.heading")}</h1>
                <p className="mt-4 mb-4 title-font-2">
                  {t("lead.subheading")}
                </p>
                <Link to="/contact" className="btn cta-accent" role="button">
                  {t("lead.cta")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Body;
